import enUS from './en-US';
import esMX from './es-MX';

const translations = {
  'en-US': enUS,
  'es-MX': esMX,
};

export default translations;
